import React from 'react';
import './HeroSection.css';

interface HeroSectionProps {
  onCopyToClipboard?: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onCopyToClipboard }) => {
  return (
    <section id="anasayfa" className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            <span className="highlight">Thermomix</span> Dünyasına Hoş Geldiniz. <br />
            <span className="highlight">TM7</span> ile Mutfakta Yeni Bir <span className="highlight">Çağ</span> Başlıyor
          </h1>
        </div>
        <div className="hero-image-container">
          <div className="hero-image-left">
            <img
              src="/assets/img/tm7/akilliyemekrobotu-thermomix-tm7-sol.webp"
              alt="Thermomix TM7"
              className="hero-image"
            />
          </div>
          <div className="hero-image-center">
            <img
              src="/assets/img/tm7/akilliyemekrobotu-thermomix-tm7.webp"
              alt="Thermomix TM7"
              className="hero-image"
            />
          </div>
        </div>
        <div className="hero-info">
          <div className="hero-info-content">
            <div className="hero-info-text">
              <div className="hero-text-block">
                <p>
                  Bir bebek annesi olarak, mutfakta zamanın ne kadar değerli olduğunu çok iyi biliyorum.
                  Aileme <span className="text-highlight">sağlıklı</span> ve <span className="text-highlight">ev yapımı</span> yemekler hazırlamak isterken, bir yandan da hayatın hızına yetişmeye çalışıyorum.
                </p>
                <p className="emphasis-text">
                  <a href="#siparis" className="info-link"><span className="highlight">Thermomix</span></a>, annelerin en büyük ihtiyacı olan şeyi sunuyor:
                  <strong>Zaman ve Pratiklik.</strong>
                </p>
              </div>

              <div className="hero-text-block">
                <p>
                  Ben de tam bu yüzden <a href="#siparis" className="info-link"><span className="highlight">Thermomix</span></a> dünyasına adım attım.
                  Anne olduktan sonra vaktin kıymetini yeniden keşfettim.
                  Şimdi ise öğrendiğim her şeyi diğer annelerle paylaşmak için buradayım.
                </p>
              </div>

              <div className="hero-cta-block">
                <p className="slogan">Sen sadece hayatını yaşa…</p>
                <p className="slogan-main">Yemekleri <a href="#siparis" className="info-link"><span className="highlight">Thermomix</span></a> yapsın.</p>
                <p className="support-text">
                  Danışmanlık, kurulum, kullanım eğitimi ve tarif desteğiyle{" "}
                  <a href="#siparis" className="info-link">
                    <span className="highlight">yanındayım!</span>
                  </a>
                </p>
              </div>

            </div>

          </div>
          <div className="hero-description">
            <div className="quote-text">
              Dakikalar içinde şef profesyonelliği
            </div>
            <div className="features-list">
              <div className="feature-item">
                <span className="feature-icon">✨</span>
                <span>Şef profesyonelliği dakikalar içinde!</span>
              </div>
              <div className="feature-item">
                <span className="feature-icon">✨</span>
                <span>Zamandan tasarruf, lezzetten taviz yok.</span>
              </div>
              <div className="welcome-text">
                Thermomix Dünyası’na hoş geldin
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
